import React, { useState, Suspense, useEffect, useRef } from 'react'
import Oval from 'react-loading-icons/dist/esm/components/oval';
import { useDispatch, useSelector } from 'react-redux';
import { Await, defer, useLoaderData, useNavigate } from 'react-router-dom';
import { getAllUsersPaged, getCompanyUserList, UserPowerSearch, } from '../../Api Methods/Api';
import UsersGrid from '../../components/GridList/UsersGrid';
import FilterSearch from '../../components/PowerSearch/PowerSearch';
import FilterUsersSearch from '../../components/PowerSearch/FilterUsersSearch';

import classes from "./UserManagementPage.module.css"
import UserList from './UserManagementList';
import GridPaginationControls from '../../components/Table/Table/GridPaginationControls';
import DataManager from '../../hooks/DataManager';
import Stats2 from '../../components/UI/Stats/Stats2';
import Button2 from '../../components/UI/Button/Button2';
import Button1 from '../../components/UI/Button/Button1';
import Modal from '../../components/Modal/Modal';
import Input from '../../components/CustomDropDown/Input/Input';
import CreateUserForm from './CreateUserForm';
import FullAccountRegistration from '../../Register/fullAccountRegistration';
import CreateUser from '../../Register/CreateUser';

import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import cross from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'
import wait from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/loading.png'
import { Dropdown } from 'primereact/dropdown';
import { useBreakpointValue } from 'rsuite';
import MassCreateUserForm from '../../components/forms/MassCreateUserForm';

const UserManagementPageCardGrid = () => {

  const dataManager = new DataManager();

  const [filteredResults, setFilteredResults] = useState([]);
  const [resultCount, setResultCount] = useState(0)
  const client = useSelector(state => state.auth.client);
  const token = useSelector(state => state.auth.token);

  const [success, setSuccess] = useState(false)
    const [massSuccess, setMassSuccess] = useState(false)
  const [fail, setFail] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState("Processing file...")
  const [countProcessed, setCountProcessed] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [reason, setReason] = useState("")
  const [newUserEmail, setNewUserEmail] = useState("")
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const apiData = {
    token,
    client
  }

  const [pageSize, setPageSize] = useState(100);
  const [pageNumber, setPageNumber] = useState(dataManager.getItem('usersPageNumber'));
  const [totalUsers, setTotalUsers] = useState();
  const [totalPages, setTotalPages] = useState();
  const [reset, setReset] = useState(0)

  const [modalComponent, setModalComponent] = useState(null)
  const ModalDialog = useRef();

  const HandleShowModal = () => {
    ModalDialog.current.open();
  }

  const HandleCloseModal = () => {
    ModalDialog.current.close();
  }

  const userEmailRef = useRef();
  const userPincodeRef = useRef();

  const [userEmailAddress, setUserEmailAddress] = useState("")
  const [userPassword, setUserPassword] = useState("")


  //Fetch all users on mount
  useEffect(() => {
    const GetAllUsersPaged = async () => {
      const response = await getAllUsersPaged(apiData, pageSize, pageNumber, dispatch);
      console.log(response)
      setFilteredResults(response[0].users)
      setResultCount(response[0].users.length)
      console.log(response[0].users.length)
      setTotalUsers(response[0].totalUsers)
      setStatsLoading(false)
      if (dataManager.getItem('userSearchQuery') == "") {
        setIsLoading(false)
      }

      setTotalPages(Math.round(totalUsers / pageSize));
    }

    GetAllUsersPaged();
  }, [pageSize, pageNumber, reset])

  const HandleNextPage = () => {
    setPageNumber(prevPageNumber => prevPageNumber + 1)
    dataManager.setItem('usersPageNumber', prevPageNumber => prevPageNumber + 1)
  }

  const HandlePreviousPage = () => {
    setPageNumber(prevPageNumber => prevPageNumber - 1)
    dataManager.setItem('usersPageNumber', prevPageNumber => prevPageNumber - 1)
  }

  const [searchQuery, setSearchQuery] = useState(dataManager.getItem('userSearchQuery') || '');
  const [isLoading, setIsLoading] = useState(true)
  const [statsLoading, setStatsLoading] = useState(true)

  useEffect(() => {
    dataManager.setItem('userSearchQuery', searchQuery)
  }, [searchQuery])

  const handleFilterLogic = async (data, searchQuery, selectedCategories) => {
    const users = await data;
    setFilteredResults(users);
    setIsLoading(false)
  };

  const submitHandler = async () => {
    HandleCloseModal()
  }

  useEffect(() => {

    if (success) {
      setSuccess(false)
      successPopup()
    }

    if (massSuccess){
      setMassSuccess(false)
      massSuccessPopup()
    }

    if (fail) {
      setFail(false)
      failPopup()
    }

    if (loading){
      setLoading(false)
      loadingPopup()
    }
  }, [success, fail, loading, massSuccess])

  const HandleViewUser = async () => {
    if (newUserEmail !== ""){
        const userResponse = await UserPowerSearch(apiData, newUserEmail, dispatch)
        const user = userResponse[0].users[0]
        console.log(user)

        dataManager.setItem('clickedUserObj', user)
        dataManager.setItem('clickedUserEmailAddress', user.email)
        dataManager.setItem('clickedUserID', user.id)
        navigate('/Dashboard/Users/UserSites')
    }
  }

  const successPopup = () => {
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={check}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>User created!</h3>
          <br></br>
          <h3 style={{ textAlign: "center", color: "#858585" }}>What would you like to do next?</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          <br></br>
          <Button1 onClick={HandleViewUser} style={{ width: "100%" }}>View user</Button1>
          <br></br>
          <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
        </div>
      </div>
    )

    HandleShowModal();
  }

    const massSuccessPopup = () => {
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={check}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{`${totalCount} users created successfully!`}</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          <br></br>
          <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
        </div>
      </div>
    )

    HandleShowModal();
  }

  const failPopup = () => {
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.ModalIcon} src={cross}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>Failed to create user!</h3>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{reason}</h3>
        </div>
        <br></br>
        <br></br>
        <div>
          <br></br>
          <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
        </div>
      </div>
    )

    HandleShowModal();
  }

  const loadingPopup = () => {
    setModalComponent(
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <img className={classes.LoadingModalIcon} src={wait}>
        </img>
        <br></br>
        <br></br>
        <div>
          <h3 style={{ textAlign: "center", color: "#858585" }}>{`Creating ${totalCount} accounts, please wait...`}</h3>
          {/* <h3 style={{ textAlign: "center", color: "#858585" }}>{`${countProcessed} of ${totalCount} users created`}</h3> */}
        </div>
        <br></br>
        <br></br>
      </div>
    )

    HandleShowModal();
  }

  const options = [
    "Create single user",
    "Create multiple users"
  ]

  

  const showCreateUserForm = () => {
    setModalComponent(
      <CreateUser
        HandleCloseModal={HandleCloseModal}
        setSuccess={setSuccess}
        setFail={setFail}
        setReason={setReason}
        setNewUserEmail={setNewUserEmail}
        apiData={apiData}
      />
    )
    HandleShowModal();
  };

  const showMassCreateUserForm = () => {
    setModalComponent(
      <MassCreateUserForm
        setSuccess={setMassSuccess}
        setFail={setFail}
        setLoading={setLoading}
        countProcessed={countProcessed}
        setCountProcessed={setCountProcessed}
        setTotalCount={setTotalCount}
        apiData={apiData}
      />
    )
    HandleShowModal();
  };

  useEffect(() => {
    console.log(countProcessed)
  }, [countProcessed])

  const setSelectedOption = (option) => {
    switch (option){
      case "Create single user":
        showCreateUserForm()
        break;
      case "Create multiple users":
        showMassCreateUserForm()
        break;
    }
  }

  return (
    <>
      <Modal ref={ModalDialog} title={"Create user"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
        {modalComponent}
      </Modal>

      <div className={classes['userManagementPage_container']}>
        <Await resolve={totalUsers}>
          {(loadedTotalUsers) =>
            <div style={{ display: "flex", width: "100%" }}>
              <Stats2 title={"Total active users"} value={loadedTotalUsers} isLoadingStats={statsLoading} isStatic={true} />
            </div>
          }
        </Await>


        <div style={{ display: 'flex', alignItems: 'baseline' }}>
          <FilterUsersSearch
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            placeholder="Start typing to search users..."
            setIsLoading={setIsLoading}
            setFilteredResults={setFilteredResults}
            handleFilterLogic={handleFilterLogic}
            categories={["Online", "Offline", "Notifications On", "Notifications Off", "Favorited", "Not Favorited"]}
            reset={reset}
            setReset={setReset}
          />



          <Dropdown 
            style={{marginLeft:"20px"}}
            onChange={(e) => setSelectedOption(e.value)} 
            options={options} 
            placeholder="Create user(s)" 
            className="w-full md:w-14rem" 
          />
        </div>



        <Suspense
          fallback={
            <div className={classes["loadingSpinner-container"]}>
            </div>
          }>
          <Await resolve={filteredResults}>

            {(loadedFilteredResults) =>
              <div>
                <div style={{ display: "flex", width: "100%" }}>
                  <UserList data={loadedFilteredResults} apiData={apiData} searchQuery={searchQuery} isLoading={isLoading} setIsLoading={setIsLoading} />
                </div>
                <br></br>
                <div>
                  <GridPaginationControls
                    pageIndex={pageNumber}
                    nextPage={HandleNextPage}
                    previousPage={HandlePreviousPage}
                    setPageIndex={setPageNumber}
                    pageCount={totalPages}
                    setPageSize={setPageSize}
                    PageSize={pageSize}
                    totalDevices={totalUsers} //Total user count
                    setTotalDevices={setTotalUsers} //set total user count
                  />
                </div>
              </div>
            }
          </Await>
        </Suspense>
      </div>
    </>
  )
}

export default UserManagementPageCardGrid

export async function loader() {
  const token = localStorage.getItem('token');
  const client = localStorage.getItem('client');
  const companyName = localStorage.getItem('companyName');

  const apiData = {
    token,
    client
  }

  return defer({
    // portalUsers: getCompanyUserList(apiData, companyName),
  })
}
